import { Stack, IconButton, Tooltip } from '@mui/material';
import { Launch } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router';
import type { SessionDto } from '@/types/dtos/sessions/session.dto.ts';
import { SessionToggleLibrary } from './session-toggle-library';
import { useFlowStore } from '@/state/stores/use-flow-store';
import { useTranslations } from '@/i18n/use-translations.tsx';

export { SessionDelete } from './session-delete';
export { SessionToggleLibrary } from './session-toggle-library';
export { SessionPublish } from './session-publish';

export const SessionActions = ({ session }: { session: SessionDto }) => {
  const flow = useFlowStore((s) => s.flow);
  const navigate = useNavigate();
  const { eventId } = useParams();
  const t = useTranslations();

  // Only show navigation button in flow context and when session is in library
  const isFlowContext = !!flow;
  const showNavigateToSessionList = isFlowContext && session.isInLibrary;

  const handleNavigateToSessionList = () => {
    if (eventId) {
      navigate(`/event/${eventId}?tab=sessions&key=${session.id}`);
    }
  };

  return (
    <Stack direction="row" spacing={0.5}>
      {showNavigateToSessionList && (
        <Tooltip title={t('session.navigateToSessionList')}>
          <IconButton size="small" onClick={handleNavigateToSessionList} aria-label="Go to session list">
            <Launch fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {/* Only show library toggle in flow context, not in session list */}
      {isFlowContext && <SessionToggleLibrary session={session} />}
    </Stack>
  );
};
